
import { Component, Vue } from 'vue-property-decorator';
// @ is an alias to /src
import SearchLanding from '../components/SearchLanding.vue';
import PostLanding from '../components/PostLanding.vue';
import TitledSection from '../components/TitledSection.vue';
import BusinessesListingLanding from '../components/BusinessesListingLanding.vue';
import ObservedPromise from 'spa-ionata-admin/lib/services/ObservedPromise';
import { CollectionProxy } from 'spraypaint/lib-esm/proxies';
import Post, { PersistedPost, PostProxy } from '@/models/Post';

@Component({
  components: {
    SearchLanding,
    PostLanding,
    BusinessesListingLanding,
    TitledSection,
  },
})
export default class Home extends Vue {
  homepagePromise!: ObservedPromise<PostProxy>;

  get homepage() {
    return this.homepagePromise.value?.data || null;
  }

  get sectionIds(): string[] | undefined {
    return (this.homepage?.metadata || {}).sections;
  }

  get homepageLoading() {
    return this.homepagePromise.isPending;
  }

  get sectionsLoading() {
    return this.sectionsPromise.isPending;
  }

  get sectionsPromise(): ObservedPromise<CollectionProxy<Post>> {
    const { sectionIds } = this;
    if (sectionIds?.length) {
      const promise = (async () => {
        try {
          return await Post.where({ id__in: this.sectionIds }).all();
        } catch (_err) {
          // TODO: remove when server adds support for `/posts/filter[id__in]=x,y,z`
          const proxy = await Post.all();
          const lookup = new Map(proxy.data.map(item => [item.id, item]));
          const items = sectionIds
            .map(id => lookup.get(id))
            .filter(a => a) as PersistedPost[];
          proxy.data.splice(0, proxy.data.length);
          items.forEach(item => proxy.data.push(item));
          return proxy;
        }
      })();
      return new ObservedPromise(promise);
    }
    return new ObservedPromise();
  }

  get sections(): PersistedPost[] {
    return this.sectionsPromise.value?.data || [];
  }

  get sectionsMap(): Record<string, PersistedPost> {
    const map: Record<string, PersistedPost> = {};
    this.sections.forEach(item => {
      map[item.id] = item;
    });
    return map;
  }

  created() {
    const promise = Post.where({ slug: 'homepage' }).first();
    this.homepagePromise = new ObservedPromise(promise);
  }

  onSearch(data: SearchData) {
    const { search, category, sector, exportMarket } = data;
    const query: Partial<SearchQuery> = {};
    if (search) query.q = search;
    if (category) query.c = category;
    if (sector) query.s = sector;
    if (exportMarket) query.em = exportMarket;
    this.$router.push({
      path: '/search',
      query,
      hash:
        search || category || sector || exportMarket ? 'results' : undefined,
    });
  }
}
